import * as React from 'react'
import { useDispatch } from 'redux-react-hook'
import { setPage } from '../../../actions/header.action'
import { setInquiryDetails } from '../../../actions/inquiry.action'
import { getPatientDetails } from '../../../actions/patient.action'
import { Header } from '../../molecules/header/index'
import styled from 'styled-components'
import { Size } from '../../../constants/app.constant'
import Contents from './contents'
import * as HeaderConst from '../../../constants/header.constant'
import useGetState from '../../../hooks/use-get-state'
import useFetchApi from '../../../hooks/use-fetch-api'

const { useEffect } = React

// const InquiryDetail: React.SFC = ({ match }) => {
const InquiryDetail = ({ match }) => {
  // ${auth.user.idToken.payload['custom:userId']}
  const dispatch = useDispatch()
  const {
    state: { auth },
  } = useGetState()
  const { isLoading, response } = useFetchApi({
    method: 'GET',
    url: `inquiries/details/${encodeURI(match.params.inquiryId)}`,
  })
  useEffect(
    () => {
      document.title = '問い合わせ詳細画面'
      dispatch(setPage(HeaderConst.HEADER_REPORT))
      dispatch(
        getPatientDetails({
          patientId: auth.user.idToken.payload['custom:userId'],
          jwtToken: auth.user.idToken.jwtToken,
        })
      )
    },
    [auth.user.idToken.jwtToken, auth.user.idToken.payload, dispatch]
  )
  useEffect(
    () => {
      console.log(response)
      if (response) dispatch(setInquiryDetails(response))
    },
    [dispatch, response]
  )
  return (
    !isLoading && (
      <Wrapper>
        <Header />
        <Contents />
      </Wrapper>
    )
  )
}
export default InquiryDetail
const Wrapper = styled.div`
  max-width: ${Size.BREAK_POINT.MOBILE}px;
  background: white;
  margin: 0 auto;
`



// WEBPACK FOOTER //
// ./src/components/pages/inquiry_detail/inquiry_detail.tsx